import { extractCollectionRows, getChildCollections } from './collections-tree';

export function flattenAllCollections(data) {
    const roots = extractCollectionRows(data);
    if (!roots.length) return [];

    const flat = [];
    const seen = new Set();

    const walk = (nodes) => {
        nodes.forEach((node) => {
            if (!node?.id || seen.has(String(node.id))) return;
            seen.add(String(node.id));
            flat.push(node);

            const children = getChildCollections(node);
            if (Array.isArray(children) && children.length) {
                walk(children);
            }
        });
    };

    walk(roots);

    if (roots.some((row) => row.parent_id)) {
        roots.forEach((row) => {
            if (!seen.has(String(row.id))) {
                seen.add(String(row.id));
                flat.push(row);
            }
        });
    }

    return flat;
}

export function buildCollectionsById(data) {
    const map = {};
    flattenAllCollections(data).forEach((row) => {
        map[String(row.id)] = row;
    });
    return map;
}

export function getProductCollectionLabels(product, collectionsById) {
    const links = product?.collections || product?.product_collections || [];
    const categories = [];
    const subcategories = [];

    links.forEach((link) => {
        const collectionId = String(link.collection_id || link.id);
        const row = collectionsById[collectionId];
        if (!row?.name) return;

        if (row.parent_id) {
            subcategories.push(row.name);
            const parent = collectionsById[String(row.parent_id)];
            if (parent?.name && !categories.includes(parent.name)) {
                categories.push(parent.name);
            }
        } else {
            categories.push(row.name);
        }
    });

    return {
        categories: categories.join(', '),
        subcategories: subcategories.join(', '),
    };
}
